<template>
  <sc-modal :active.sync="modalActive" @close="closeModal">
    <sc-modal-card>
      <template slot="title">
        <h2 class="modal-card-title notification-title">Termos e condições:</h2>
      </template>
      <template slot="body">
       <div>
        <strong>Termos e condições:</strong>
          <p>Todas as solicitações de novas integrações agora passam por uma revisão do comercial de até dois dias úteis. Se exceder a quantidade contratada, será feita uma proposta no valor acordado em contrato para adição de transportadoras. Caso seja aprovada para produção, passa a contar o prazo de sete dias úteis. Os prazos de produção começam a contar após a validação comercial ou quando o pagamento da nova transportadora é registrado.</p>
          <p>ATENÇÃO: As interações sobre dúvidas, dados faltantes ou finalização da integração em ambiente teste de qualquer chamado serão sempre enviadas para o e-mail informado neste formulário (E-mail do solicitante). Serão feitas até três tentativas de contato com o cliente com espaço de três dias úteis entre uma e outra. Ao totalizar nove dias sem qualquer interação, o chamado será automaticamente fechado e será necessário abrir outro caso queira cadastrar ou atualizar a transportadora em questão.</p>
       </div>
      </template>
    </sc-modal-card>
  </sc-modal>
</template>
<script>
  import {
    ScModal,
    ScModalCard,
  } from '@intelipost-js/secure-components';

  export default {
    name: 'modal-term',

    props: {
      modalActive: {
        type: Boolean,
      },
    },
    data() {
      return {
        localModalActive: this.modalActive,
      };
    },
    methods: {
      closeModal() {
        this.$emit('close');
      },
    },
    components: {
      ScModal,
      ScModalCard,
    },
  };
</script>

<style lang="scss">
  
</style>
  


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-self-service/logistic-provider-form/components/ScTermModal/ScTermModal.vue